import { render, staticRenderFns } from "./wl-dialog.vue?vue&type=template&id=c2cfed88&scoped=true&lang=pug"
import script from "./wl-dialog.js?vue&type=script&lang=js&external"
export * from "./wl-dialog.js?vue&type=script&lang=js&external"
import style0 from "./wl-dialog.styl?vue&type=style&index=0&id=c2cfed88&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cfed88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2cfed88')) {
      api.createRecord('c2cfed88', component.options)
    } else {
      api.reload('c2cfed88', component.options)
    }
    module.hot.accept("./wl-dialog.vue?vue&type=template&id=c2cfed88&scoped=true&lang=pug", function () {
      api.rerender('c2cfed88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-dialog/wl-dialog.vue"
export default component.exports